import {
  TOGGLE_ADD_ADDRESS,
  TOGGLE_EDIT_ADDRESS,
  SUBMIT_ADDRESS_SCREEN,
  SUBMIT_SHIPPING_SCREEN,
} from '../actions/screens';

const initialState = {
  errorMessage: null,
  isAddAddressShown: false,
};

const checkoutScreensReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_ADD_ADDRESS:
      return Object.assign({}, state, {
        isAddAddressShown: !state.isAddAddressShown,
      });
    case TOGGLE_EDIT_ADDRESS:
      return Object.assign({}, state, {
        isEditAddressShown: !state.isEditAddressShown,
        addressToEdit: action.value,
      });
    case SUBMIT_ADDRESS_SCREEN:
      // NOTE: Only needed for redux-observable side-effect
      return state;
    case SUBMIT_SHIPPING_SCREEN:
      // NOTE: Only needed for redux-observable side-effect
      return state;

    default:
      return state;
  }
};

export default checkoutScreensReducer;
